'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CheckboxFilter: ()=>CheckboxFilter
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../Checkbox/index.cjs");
const external_LabelNode_cjs_namespaceObject = require("./LabelNode.cjs");
function CheckboxFilter({ checked, disabled, facet, handleChange, handleOnlyClick, helperText, iconName, imgSrc, imgAlt, label, name, nestedFilters, showOnlyButton, value }) {
    const labelStyles = 'rounded-md ring-primary-2 hover:bg-primary-2 transition duration-300 hover:ring';
    const nestedFilterOptions = nestedFilters && nestedFilters.length > 1 ? nestedFilters.map((filter, index)=>{
        const { disabled, facet, helperText, iconName, imgSrc, imgAlt, label, showOnlyButton, value } = filter;
        const labelNode = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_LabelNode_cjs_namespaceObject.LabelNode, {
            disabled: disabled,
            facet: facet,
            handleOnlyClick: ()=>handleOnlyClick?.(value),
            helperText: helperText,
            iconName: iconName,
            imgAlt: imgAlt,
            imgSrc: imgSrc,
            label: label,
            showOnlyButton: showOnlyButton
        }, value);
        return {
            ...filter,
            labelClassName: index > 0 ? `${labelStyles} pl-4 w-full` : `${labelStyles}`,
            labelNode
        };
    }) : null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "w-full",
        children: nestedFilterOptions ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CheckboxGroup, {
            options: nestedFilterOptions,
            handleChange: handleChange,
            isCollapsible: true,
            triggerClassName: labelStyles,
            className: "w-full"
        }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CheckboxWithLabel, {
            labelClassName: `${labelStyles}`,
            labelNode: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_LabelNode_cjs_namespaceObject.LabelNode, {
                disabled: disabled,
                facet: facet,
                handleOnlyClick: handleOnlyClick,
                helperText: helperText,
                iconName: iconName,
                imgAlt: imgAlt,
                imgSrc: imgSrc,
                label: label,
                showOnlyButton: showOnlyButton
            }),
            handleChange: handleChange,
            checked: checked,
            disabled: disabled,
            name: name,
            size: "20",
            value: value
        })
    });
}
exports.CheckboxFilter = __webpack_exports__.CheckboxFilter;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CheckboxFilter"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
